import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Input } from '@angular/core';

@Component({
  selector: 'app-weather-time',
  standalone: true,
  imports: [NgFor, NgIf],
  templateUrl: './weather-time.component.html'
})
export class WeatherTimeComponent {

  @Input()
  public coords: any;

  public weather: any = {
    icon: 'bi-sun',
    temp: null,
    description: ''
  };

  public timeTempString: any;

  public weatherObjects = [
    { text: 'Soleado', icon: 'bi-sun', name: 'Clear' },
    { text: 'Nubes', icon: 'bi-clouds', name: 'Clouds' },
    { text: 'Lluvioso', icon: 'bi-cloud-drizzle', name: 'Rain' }
  ];

  public weatherIcon: string = '';

  public showWeatherIcon: boolean = true;
  public isLoading: boolean = true;

  private readonly apiKey = "fd0cdfbf77038d0221a18be9b99a8a57";

  constructor(private _cdr: ChangeDetectorRef) {
    setInterval(async() => this._getWeather(), 60000);
    setInterval(() => this._getTime(), 1000);
    setInterval(() => this._changeTempTimeDisplay(), 8000);
  }

  private async _getWeather(): Promise<any> {
    try {
      const url = `https://api.openweathermap.org/data/2.5/weather?lat=${this.coords.lat}&lon=${this.coords.lng}&appid=${this.apiKey}&units=metric`;
      
      const response = await fetch(url);
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      
      if (data.main?.temp && data.weather) {
        this.weather.temp = Math.round(data.main.temp);
        this._getWeatherIcon(data.weather[0].main);
        this.isLoading = false;
        this._cdr.detectChanges();
      } else {
        console.warn('Weather data not found in response');
        this.isLoading = false;
        this._cdr.detectChanges();
      }
    } catch (error) {
      console.error('Error fetching weather data:', error);
    }
  }

  private _getWeatherIcon(name: string) {
    let item = this.weatherObjects.find(weatherObject => weatherObject.name === name);
    
    this.weather.icon = item?.icon;
    this.weather.description = item?.text;
    this.weatherIcon = '<i class="bi ' + item?.icon + '"></i> ' + item?.text;
  }

  private _getTime(): void {
    const now = new Date();
    const hour = now.getHours();
    const minute = now.getMinutes().toString().padStart(2, '0');
    let time = `${hour}:${minute}`;
    let temp = this.weather.temp + '°C - ';

    if (this.weather.temp !== null) {
      this.timeTempString = `${temp} ${time}`;
    } else {
      this.timeTempString = `${time}`;
    }
  }

  private _changeTempTimeDisplay(): void {
    if (this.weather.description) {
      this.showWeatherIcon = !this.showWeatherIcon;
      this._cdr.detectChanges();
    } else {
      this._getWeather();
    }
  }
}
